// Packages
import axios from "axios";
import { axiosInstance } from "..";
import Cookies from "js-cookie";

export const registerApi = async (formData: FormData) => {
  // const body = JSON.stringify(formData);
  const response = await axios.post("api/register", formData);

  if (response.status === 200 && response.data.message === "Email Registered") {
    return response.data.message;
  }

  return response.data;
};

export const getUserDetailsApi = async (userId: string) => {
  const config = {
    params: {
      userId: userId,
    },
  };
  const response = await axiosInstance.get("api/getUserDetails", config);

  if (response.status !== 200) {
    return null;
  }

  return response.data;
};

export const updateUserDetailsApi = async (formData: FormData) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    withCredentials: true,
  };
  const response = await axiosInstance.post("api/updateUserDetails", formData, config);

//   if (response.status === 200) {
//     return response.data.message;
//   }
  return response
};

export const uploadProfilePicApi = async (formData: FormData) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    withCredentials: true,
  };
  const response = await axiosInstance.post("api/uploadProfilePic", formData, config);
  return response
};

export const getUnbannedUserList = async(userId: string) => {
  const config = {
    params: {
        userId: userId
    },
    withCredentials: true,
  };
  const response = await axiosInstance.get("api/getUnbannedUser", config);
  return response;
}

export const getBannedUserList = async(userId: string) => {
  const config = {
    params: {
        userId: userId
    },
    withCredentials: true,
  };
  const response = await axiosInstance.get("api/getBannedUser", config);
  return response;
}

export const banUserApi = async (targetUserId: number, userId: string) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    params: {
        targetUserId: targetUserId,
        userId: userId
    },
    withCredentials: true,
  };
  
  const response = await axiosInstance.post("api/banUser", null, config)
  return response
}

export const unbanUserApi = async (targetUserId: number, userId: string) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    params: {
        targetUserId: targetUserId,
        userId: userId
    },
    withCredentials: true,
  };
  
  const response = await axiosInstance.post("api/unbanUser", null, config)
  return response
}

export const changePasswordApi = async (formData: FormData, userId: string) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    params: {
        userId: userId
    },
    withCredentials: true,
  };

  const response = await axiosInstance.post("api/changePassword", formData, config)
  return response
}

export const resetGetUsernameApi = async (username: string) => {
  const config = {
    params: {
      username: username
    }
  }

    const response = await axios.get("api/resetGetUsername", config)
    return response
}

export const resetChangePasswordApi = async (formData: FormData) => {
  var csrfCookie = Cookies.get("csrftoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfCookie ? csrfCookie : 0,
    },
    withCredentials: true,
  };

  const response = await axios.post("api/resetChangePassword", formData, config)
  return response
}